"use client";

import { Suspense } from "react";
import { LoginBox } from "@/components/auth/login/LoginBox";
import { VibrantOrbBackground } from "@/components/ui/VibrantOrbBackground";
import { getLastLogoVisited } from "@/lib/last-logo-visited";

export default function LoginPage() {
  const lastLogoVisited = getLastLogoVisited();

  return (
    <VibrantOrbBackground>
      <Suspense fallback={<div>Loading...</div>}>
        <LoginBox logoUrl={lastLogoVisited} />
      </Suspense>
    </VibrantOrbBackground>
  );
}
